var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VHover',{staticClass:"office-photo-item",scopedSlots:_vm._u([{key:"default",fn:function(ref){
var hover = ref.hover;
return [_c('VSheet',{attrs:{"elevation":hover ? 5 : 2}},[_c('VImg',{attrs:{"src":_vm.photo.preview.url,"width":167,"height":100},on:{"load":function($event){return _vm.$emit('load')}}})],1)]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }